import "./style.scss";

function ImgPerfil({ img }) {
  return <img className="img" src={img} alt="img Perfil" />;
}

export default ImgPerfil;
